module.exports = __webpack_public_path__ + "categories/icon-feature-illustrator-35bfbf87eccafd2a2307d9fe74bc86c9.svg";